export default __webpack_public_path__ + "static/media/dyeing3.1299697e.png";